import { downloadZip } from 'helper/downloadFile';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { selectMWComparatorControlPanelModel } from 'redux/reducers/meteorologyWeatherComparatorControlPanelReducer';
import { SeasonalComparatorImages } from 'types/Meteorology/Weather/SeasonalComparator/getImages';

export default function useImagesDownload(
  images: SeasonalComparatorImages | undefined,
  loading: boolean,
) {
  const downloadDisabled = loading || !images;
  const models = useSelector(selectMWComparatorControlPanelModel);
  const onDownloadClick = useCallback(() => {
    if (!downloadDisabled) {
      const files = [
        { filename: `modelo_1_${models[0]}.png`, content: images?.firstModelImage },
        { filename: `modelo_2_${models[1]}.png`, content: images?.secondModelImage },
        { filename: 'diferença.png', content: images?.differenceImage },
      ];
      const date = new Date();
      const zipFilename = `comparador_sazonal_${date.toLocaleString('pt-BR').replace(/\/|:|,|\s/g, '_')}.zip`;
      downloadZip(files, zipFilename);
    }
  }, [downloadDisabled, images, models]);

  return {
    onDownloadClick,
    downloadDisabled,
  };
}
